import Calendar from "components/base/Calendar";
import { useState } from "react";

const Holidays = ({ offDates }) => {
  const [year, setYear] = useState(new Date().getFullYear());

  return (
    <Calendar
      year={year}
      setYear={setYear}
      selectedDates={offDates.map((i) => i.date)}
    />
  );
};

export default Holidays;
